import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../services/api'

/**
 * Holds the active broker (from the backend /config endpoint) so the UI can hide
 * broker-specific sections (e.g. don't show E*TRADE info when IBKR is active).
 */
export const useBrokerStore = defineStore('broker', () => {
  const broker = ref<string>('etrade')
  const brokerLabel = ref<string>('E*TRADE')
  const marketExchange = ref<string>('NASDAQ')
  const loaded = ref(false)

  const isEtrade = computed(() => broker.value === 'etrade')
  const isIbkr = computed(() => broker.value === 'ibkr')

  const load = async () => {
    try {
      const res = await api.config.get()
      const data = (res as { data: any }).data || {}
      broker.value = (data.broker || 'etrade').toLowerCase()
      brokerLabel.value = data.broker_label || (broker.value === 'ibkr' ? 'IBKR' : 'E*TRADE')
      marketExchange.value = data.market_exchange || 'NASDAQ'
    } catch (e) {
      console.error('Failed to load broker config:', e)
    } finally {
      loaded.value = true
    }
  }

  return { broker, brokerLabel, marketExchange, loaded, isEtrade, isIbkr, load }
})
